export default {
  blueInvoiceInfo: {}, // 发票列表的信息
  setPlateNumber: '', // 车牌信息
  itemInvoiceInfo: {}, // 某条发票的信息
  itemBillInfo: {} // 账单信息
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/state.js